import React, { useEffect, useState } from 'react';
import { ConfigProvider } from 'antd';
import { useDispatch, useSelector } from 'react-redux';

import RawDataFilters from '../../components/RawDataFilters';
import DataRecordsContainer from '../../container/rawData/rawDataComponents/DataRecordsContainer';
import StepperCard from '../../container/rawData/sequentialFlow/StepperCard';
import SequentialRecordsContainer from '../../container/rawData/sequentialFlow/SequentialFlowContainer';
import PastRecords from '../../components/PastRecords/PastRecords';

import "../../css/rawdata.css";
import '../../css/rawDataPage.css';

const RawDataPage = () => {
  const { pastRecords, globalFilters } = useSelector(state => state.rawData);

  const [showStepperCard, setShowStepperCard] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [selectedCasperId, setSelectedCasperId] = useState('');
  const [selectedCasperIdInFilters, setSelectedCasperIdInFilters] = useState('');
  const [selectedCardsWithEssentialData, setSelectedCardsWithEssentialData] = useState({});
  const [selectedUniqueIdAuditTrace, setSelectedUniqueIdAuditTrace] = useState('');
  const [iMONumber, setIMONumber] = useState(globalFilters?.imoNumber || "");
  const [voyageYear, setVoyageYear] = useState(globalFilters?.year || new Date().getFullYear());

  // CLEAR DATA ON PAGE LOAD / REFRESH
  useEffect(() => {
    sessionStorage.removeItem("biofuelCompositionData");
    sessionStorage.removeItem("biofuelBlendInfoData");
  }, []);

  const handleAssignCasperID = () => {
    setShowStepperCard(true);
  };

  const handleBack = () => {
    setCurrentStep(0);
    setShowStepperCard(false);
  };

  const handleStepChange = (step) => {
    setCurrentStep(step);
  };

  const renderContent = () => {
    if (showStepperCard) {
      return (
        <>
          <div className='card' style={{ width: '100%', height: '25vh' }}>
            <StepperCard onBack={handleBack} currentStep={currentStep} onStepChange={handleStepChange} />
          </div>
          <SequentialRecordsContainer
            currentStep={currentStep}
            onStepChange={handleStepChange}
            setShowStepperCard={setShowStepperCard}
            selectedCasperId={selectedCasperId}
            setSelectedCasperId={setSelectedCasperId}
            selectedCardsWithEssentialData={selectedCardsWithEssentialData}
            setSelectedCardsWithEssentialData={setSelectedCardsWithEssentialData}
          />
        </>
      );
    }

    if (pastRecords) {
      return (
        <PastRecords
          selectedUniqueIdAuditTrace={selectedUniqueIdAuditTrace}
          setSelectedUniqueIdAuditTrace={setSelectedUniqueIdAuditTrace}
          selectedCasperIdAuditTrace=''
        />
      );
    }

    return (
      <>
        <RawDataFilters
          type={"Raw Data"}
          setSelectedCasperIdInFilters={setSelectedCasperIdInFilters}
          iMONumber={iMONumber}
          setIMONumber={setIMONumber}
          voyageYear={voyageYear}
          setVoyageYear={setVoyageYear}
          setSelectedCardsWithEssentialData={setSelectedCardsWithEssentialData}
        />
        <div className="MainTable" style={{ width: '98%' }}>
          <DataRecordsContainer
            onAssignCasperID={handleAssignCasperID}
            selectedCasperIdInFilters={selectedCasperIdInFilters}
            selectedUniqueIdAuditTrace={selectedUniqueIdAuditTrace}
            setSelectedUniqueIdAuditTrace={setSelectedUniqueIdAuditTrace}
            selectedCardsWithEssentialData={selectedCardsWithEssentialData}
            setSelectedCardsWithEssentialData={setSelectedCardsWithEssentialData}
          />
        </div>
      </>
    );
  };

  return (
    <ConfigProvider
      theme={{
        components: {
          Progress: { lineBorderRadius: 8 },
          Descriptions: { itemPaddingBottom: '10px' },
          Table: { headerSplitColor: '#fffff', headerBg: '#fffff' }
        },
      }}
    >
      <div className="raw-data-page">
        {renderContent()}
      </div>
    </ConfigProvider>
  );
};

export default RawDataPage;